import { useEffect, useState } from "react";
import { loadPdfDocument } from "../lib/pdfjs";

/** Returns the page count of a PDF at `url`, or null while it's loading. */
export default function usePdfPageCount(url) {
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setNumPages(null);
    if (!url) return undefined;
    loadPdfDocument(url)
      .then((pdf) => { if (!cancelled) setNumPages(pdf.numPages); })
      .catch(() => { if (!cancelled) setNumPages(0); });
    return () => { cancelled = true; };
  }, [url]);

  return numPages;
}
